import { render, staticRenderFns } from "./Compass2.vue?vue&type=template&id=72d8cdef&scoped=true&"
import script from "./Compass2.vue?vue&type=script&lang=js&"
export * from "./Compass2.vue?vue&type=script&lang=js&"
import style0 from "./Compass2.vue?vue&type=style&index=0&id=72d8cdef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d8cdef",
  null
  
)

export default component.exports